import { useGetEphemeralFiltersQuery } from '@frameio/graphql-client/generated';
import { useActiveCollectionId } from '../../contexts';
import { useMeCachedQuery } from '../../hooks/useMeCachedQuery/useMeCachedQuery';

/**
 * A wrapper for useGetEphemeralFiltersQuery.
 *
 * @returns {{
 *  ephemeralFilters: Array<MetadataFilter>
 * }}
 */
export const useGetEphemeralFilters = () => {
  const collectionId = useActiveCollectionId();
  const userId = useMeCachedQuery()?.data?.me?.id;
  const ephemeralFilters =
    useGetEphemeralFiltersQuery({
      variables: {
        input: {
          collectionId,
          userId,
        },
      },
      /**
       * Suggested filters are Partial<MetadataFilter>
       */
      returnPartialData: true,
      skip: !collectionId || !userId,
    })?.data?.ephemeralFilters || [];

  return { ephemeralFilters };
};
